export default {
    data() {
        return {
            processing: false,
            $loadingObj: null
        }
    },
    watch: {
        processing(processing) {            
            if (processing) {
                this.$startLoading()
            } else {
                this.$endLoading()
            }
        }
    },
    methods: {
        $startLoading() {   
            if (this.$loadingObj) {
                return
            }
            if (typeof this.processing == 'boolean') {
                this.processing = true
            }
            this.$loadingObj = this.$loading({
                background: 'rgba(0, 0, 0, 0.3)',
                lock: true
            })
        },
        $endLoading() {
            if (typeof this.processing == 'boolean') {
              this.processing = false
            }
            this.$loadingObj.close()
            this.$loadingObj = null
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixin/processing.js